// extracted by mini-css-extract-plugin
export default {"container":"g__container--INyTj","countdown-container":"g__countdown-container--MGFJz","flashing":"g__flashing--K4eND","counter-flash":"g__counter-flash--hmUB1"};